const ARIA_EXPANDED = 'aria-expanded';

const bindAriaSync = (toggleEl, hoverMediaQuery) => {
  // The panel also opens via pure CSS (:hover / :focus on the button, see
  // product-variants.liquid), so aria-expanded needs syncing from those
  // events too on devices that use that path - otherwise it stays "false"
  // while the panel is visibly open.
  const setExpanded = (isExpanded) => {
    if (!hoverMediaQuery.matches) return;
    toggleEl.setAttribute(ARIA_EXPANDED, String(isExpanded));
  };

  toggleEl.addEventListener('mouseenter', () => setExpanded(true));
  toggleEl.addEventListener('mouseleave', () => setExpanded(false));
  toggleEl.addEventListener('focus', () => setExpanded(true));
  toggleEl.addEventListener('blur', () => setExpanded(false));
};

const initSizeInfo = () => {
  const wrapperEls = document.querySelectorAll('[data-size-info]');
  if (!wrapperEls.length) return;

  // Gate on actual hover/pointer capability, not viewport width - a coarse
  // pointer (e.g. an iPad in landscape) can be >= the lg breakpoint but has
  // no reliable :hover, so it still needs the click-to-toggle path below.
  const hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  wrapperEls.forEach((wrapperEl) => {
    const toggleEl = wrapperEl.querySelector('[data-size-info-toggle]');
    const panelEl = wrapperEl.querySelector('[data-size-info-panel]');
    const closeEl = wrapperEl.querySelector('[data-size-info-close]');
    if (!toggleEl || !panelEl) return;

    const openPanel = () => {
      panelEl.classList.remove('hidden');
      toggleEl.setAttribute(ARIA_EXPANDED, 'true');
    };

    const closePanel = () => {
      panelEl.classList.add('hidden');
      toggleEl.setAttribute(ARIA_EXPANDED, 'false');
    };

    toggleEl.addEventListener('click', () => {
      if (hoverMediaQuery.matches) return;
      if (panelEl.classList.contains('hidden')) {
        openPanel();
      } else {
        closePanel();
      }
    });

    if (closeEl) {
      closeEl.addEventListener('click', closePanel);
    }

    document.addEventListener('click', (event) => {
      if (hoverMediaQuery.matches) return;
      if (!wrapperEl.contains(event.target)) closePanel();
    });

    bindAriaSync(toggleEl, hoverMediaQuery);
  });
};

export default initSizeInfo;
